// 国际化英文表达部分
export default {
  common: {
    zoom: "Zoom",
    focalLength: "Focus",
    monitoringList: "Cameras",
    cloudPortal: "EZVIZ Portal",
    confirm: "OK",
    cancel: "Cancel",
    screenshotConfirm: "Screenshot",
    jumpConfirm: "Go to EZVIZ",
  },
  player: {
    ptz_top_bottom: "PTZ up/down not supported",
    ptz_left_right: "PTZ left/right not supported",
    ptz_zoom: "Zoom not supported",
    ptz_focus: "Focus mode not supported",
  },
  warning: {
    noVideo: "No video",
    underDevelopment: "Coming soon",
    noPermission: "No permission to operate!",
  },
  tips: {
    saveScreenshot: "Save screenshot locally? (Go back to previous page)",
    jumpToCloud: "Go to EZVIZ?",
  }
};
